import {connect} from 'react-redux';
import {FileItem} from './FileItem';
import {showGlobalErrorMessage} from 'common/actions/globalErrorMessage/showGlobalErrorMessage';
import {getFile} from "../../../../../actions/files/getFile";

export default connect(
  null,
  {
    showGlobalErrorMessage,
    getFile
  }
)(FileItem);
